module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day03_09_stay-871fbd2b5d57d6711bc473d0376f2eb0.jpg";